
<template>
  <div class="addressField_content">
    <van-radio-group v-model="checked" @change="checkFreightTransportMethod">
      <div
        class="addressField_items"
        v-for="(item, index) in FreightTransportMethods"
        :key="index"
      >
        <van-radio :name="item.Id">{{ item.Name }} </van-radio>
      </div>
    </van-radio-group>
  </div>
</template>
<script>
import axios from "../commons/AxiosMethod.js"
import { showToast } from "vant"
export default {
  name: "header",
  data () {
    return {
      FreightTransportMethods: [], // 超出配送距离地址集合
      checked: ""
    }
  },
  props: {
    AttributeGroup: {}
  },
  components: {},
  mounted () {
    this.GetFreightTransportMethods()
  },
  methods: {
    // 加载货运方式
    GetFreightTransportMethods () {
      axios.apiMethod(
        "/Orders/Order/GetFreightTransportMethods",
        "get",
        {},
        (result) => {
          if (result.Code == 200) {
            this.FreightTransportMethods = result.Data
            this.checked = this.FreightTransportMethods[0].Id
          } else {
            showToast(result.Msg)
          }
        },
        (e) => {}
      )
    },
    checkFreightTransportMethod (id) {
      this.$emit("update:modelValue", id)
    }
  }
}
</script>
<style  lang="scss"  scoped>
.addressField_content {
  z-index: 100023144432;
  padding: 20px;
  .addressField_items {
    padding: 5px;
    width: calc(100% - 40px);
  }
}
</style>
